import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";
import { FgStockStates } from "./dto/fg-stock-states.enum";
import { FgStockStatus } from "./dto/fg-stock-status.enum";
import { StockStatus } from "../../../../../../apps/services/warehouse-service/src/app/stock/dto/stock-status.enum";
import { PackageTypeEnum, PackingStatus, ProductCategoryEnum, ShiftsDropDown, StockTypesEnum, TransactionType } from "@gtpl/shared-models/common-models";
import { Shifts } from "../stock-in/shifts.enum";
@Entity('stock')
export class Stock {

  @PrimaryGeneratedColumn("increment",{name:'stock_id'})
  stockId:number;

  @Column("varchar",{
    nullable:true,
    name:"lot_no"
    })
    lotNo:string;

    @Column("varchar", {
        nullable: true,
        length: 20,
        name: "soaking_time"
      })
      soakingTime: string;
    
    
      @Column("varchar", {
        nullable: true,
        length: 20,
        name: "soaking_style"
      })
      soakingStyle: string;
      @Column("int", {
        nullable: true,
        name: "pallet_code"
      })
      palletCode: number;
  
      @Column("varchar", {
        nullable: true,
        length: 50,
        name: "wh_incharge"
      })
    warehouseIncharge: string;
  @Column("int",{
      nullable:false,
      name:"sale_order_id"
      })
  saleOrderId:number;
    @Column("int",{
    nullable:true,
    name:"allocated_sale_order_id"
    })
    allocatedSaleOrderId:number;
    @Column("int",{
        nullable:true,
        name:"allocated_sale_orderitem__id"
        })
        allocatedSaleOrderItemId:number;
  @Column("int",{
      nullable:false,
      name:"sale_order_item_id"
      })
  saleOrderItemId:number;
  @Column("int",{
      nullable:false,
      name:"total_cartons",
      unsigned:true
      })
      totalCartons:number;
      @Column("int",{
        nullable:true,
        // default:0,
        name:"stockout_qunatity",
        unsigned:true
        })
        stockOutQty:number;
        @Column("int",{
            nullable:true,
            name:"stockin_qunatity",
            unsigned:true
            })
            stockInQty:number;
  @Column("int",{
      nullable:false,
      name:"total_pouches",
      unsigned:true
      })
      totalPouches:number;
  @Column("decimal",{
      nullable:false,
      name:"loose_pouches",
      precision : 10,scale:3,
      unsigned:true
      })
      loosePouches:number;
      @Column({
        type: 'enum',
        enum: PackingStatus,
        nullable: false,
        name: 'packing_completed',
        default:PackingStatus.NO,
    })
    packingCompleted: PackingStatus;
      @Column({
        type: 'enum',
        enum: PackingStatus,
        nullable: true,
        name: 'pouches_shortage',
        default:PackingStatus.NO,
    })
    pouchesShortage: PackingStatus;
      @Column({
        type: 'enum',
        enum: PackingStatus,
        nullable: true,
        name: 'cartons_shortage',
        default:PackingStatus.NO,
    })
    cartonsShortage: PackingStatus;
      @Column({
        type: 'enum',
        enum: PackingStatus,
        nullable: true,
        name: 'is_damaged',
        default:PackingStatus.NO,
    })
    isDamaged: PackingStatus;
  @Column("int",{
      nullable:false,
      default:0,
      name:"location"
      })
    location:number;
    @Column("int",{
        nullable:false,
        default:0,
        name:"zone_id"
        })
      zoneId:number;
  @Column("int",{
      nullable:false,
      default:0, 
      name:"pallet"
      })
      pallet:number;
      @Column("int",{
        nullable:true,
        name:"pack_style_id"
        })
        packStyleId:number;
  @Column("datetime", {
        nullable: true,
        name: "date"
    })
    date: Date;
    @Column({
        type: 'enum',
        enum: StockStatus,
        nullable: false,
        name: 'stock_type',
        default:"SaleOrder",
    })
    stockType: StockStatus;
    @Column({
        type: 'enum',
        enum: FgStockStatus,
        nullable: false,
        name: 'status',
        default:"StockIn",
    })
    status: FgStockStatus;
    @Column({
        type: 'enum',
        enum: FgStockStates,
        nullable: false,
        name: 'state',
        default:"Stock",
    })
    state: FgStockStates;
    @Column({
        type: 'enum',
        enum: Shifts,
        nullable: false,
        name: 'shift',
        default:Shifts.general,
    })
    shift: Shifts;
    @Column({
        type: 'enum',
        enum: TransactionType,
        nullable: false,
        name: 'transaction_type',
        default:TransactionType.rm,
    })
    transactionType: TransactionType;
    @Column({
        type: 'enum',
        enum: StockTypesEnum,
        nullable: false,
        name: 'stock_out_category',
        default:"Dispatch",
    })
    stockOutCategory: StockTypesEnum;
    @Column({
        type: 'enum',
        enum: ProductCategoryEnum,
        nullable: false,
        name: 'product_category',
        default:ProductCategoryEnum.GI,
    })
    productCategory: ProductCategoryEnum;
    @Column("int",{
        nullable:false,
        name:"brand_id"
        })
    brandId:number;
    @Column("int",{
        nullable:false,
        name:"product_id"
        })
    productId:number;
    @Column("int",{
        nullable:false,
        name:"unit_id",
        })
    plantId:number;
    @Column("int",{
        nullable:false,
        name:"varient_id"
        })
    varientId:number;
    @Column("int",{
        nullable:false,
        name:"min_grade"
        })
    minGrade:number;
    @Column("int",{
        nullable:false,
        name:"max_grade"
        })
    maxGrade:number;
    @Column("int",{
        nullable:false,
        name:"category_id"
        })
    categoryId:number;
    @Column("int",{
        nullable:true,
        name:"count"
        })
        count:number;
    @Column("int",{
        nullable:false,
        name:"pouches"
        })
    pouches:number;
    @Column("int",{
        nullable:false,
        name:"pallet_capacity",
        default:0
        })
    palletCapacity:number;
    
    @Column({
        type: 'decimal', precision: 10, scale: 3,
        nullable: false,
        name: "pouch_weight"
    })
    pouchWeight: number;

    @Column("int", {
        nullable: true,
        name: "uom_id"
      })
      uomId: number;
    @Column({
        type: 'decimal', precision: 10, scale: 3,
        nullable: true,
        name: "net_weight"
    })
    netWeight: number;
    @Column("varchar", {
        nullable: true,
        length: 50,
        name: "code"
      })
    code: string;
    @Column("varchar", {
        nullable: true,
        length: 100,
        name: "remarks"
      })
    remarks: string;
    @Column("int",{
        nullable:true,
        name:"trace_code"
        })
    traceCode:number;
    @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;

  @Column("varchar", {
      nullable: true,
      name: "created_user",
      length:50,
      default:"Admin",
  })
  createdUser: string | null;


  @UpdateDateColumn({
      name: "updated_at",
      type:'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
      nullable: true,
      name: "updated_user",
      length:50
  })
  updatedUser: string | null;

  @VersionColumn({
      default:1,
      name: "version_flag"
  })
  versionFlag: number;

  @Column("decimal",{
    nullable:false,
    name:"total_loose_pouches",
    precision : 10,scale:3,
    unsigned:true
    })
    totalLoosePouches:number;

    @Column("decimal",{
        nullable:true,
        name:"stockout_loose_pouches",
        precision : 10,scale:3,
        unsigned:true
    })
    stockOutLoosePouches:number;

    //0- pass, 1-fail
    @Column('boolean',{
        name:'antibiotic_test_result',
        default:0,
        nullable:true,
    })
    antibioticTestResult : boolean

    @Column("decimal",{
        nullable:false,
        name:"transfer_cartons",
        precision : 10,scale:3,
        unsigned:true
        })
    transferCartons:number;

    @Column("decimal",{
        nullable:false,
        name:"transfer_loose_pouches",
        precision : 10,scale:3,
        unsigned:true
        })
    transferLoosePouches:number;

    @Column('enum',{
        name:'package_type',
        enum:PackageTypeEnum
    })
    packageType: PackageTypeEnum;

    @Column('decimal',{
        name:'tare_weight',
        precision:10,scale:3
    })
    tareWeight : number

    @Column('decimal',{
        name:'quantity',
        precision:10,scale:3
    })
    quantity : number

      @Column("varchar",{
    nullable:true,
    name:"stock_in_type"
    })
    stockInType:string;

    @Column('int',{
        name:'year'
    })
    year : number
}
